import { render, staticRenderFns } from "./RequestByModulePerDayInAMonthBarChart.vue?vue&type=template&id=fb2e0666&scoped=true&"
import script from "./RequestByModulePerDayInAMonthBarChart.vue?vue&type=script&lang=js&"
export * from "./RequestByModulePerDayInAMonthBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2e0666",
  null
  
)

export default component.exports